import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist/src/constants';
import requestStatus from 'common/constants/status';

const initialState = {
  data: {
    exercises: [],
    exercise: null,
    createdExercise: null,
    exerciseRequests: []
  },
  status: {
    list: requestStatus.idle,
    find: requestStatus.idle,
    create: requestStatus.idle,
    update: requestStatus.idle,
    remove: requestStatus.idle,
    request: requestStatus.idle,
    requests: requestStatus.idle,
    approve: requestStatus.idle,
    reject: requestStatus.idle,
    deleteRequest: requestStatus.idle
  }
};

const exerciseSlice = createSlice({
  name: 'exercise',
  initialState,
  reducers: {
    // List exercises
    list(state) {
      state.status.list = requestStatus.loading;
    },
    listSuccess(state, action) {
      state.status.list = requestStatus.success;
      state.data.exercises = action.payload;
    },
    listError(state) {
      state.status.list = requestStatus.error;
    },

    // Find exercise
    find(state) {
      state.status.find = requestStatus.loading;
    },
    findSuccess(state, action) {
      state.status.find = requestStatus.success;
      state.data.exercise = action.payload;
    },
    findError(state) {
      state.status.find = requestStatus.error;
    },

    // Create exercise (admin)
    create(state) {
      state.status.create = requestStatus.loading;
      state.data.createdExercise = null;
    },
    createSuccess(state, action) {
      state.status.create = requestStatus.success;
      state.data.createdExercise = action.payload || null;
    },
    createError(state) {
      state.status.create = requestStatus.error;
    },

    // Update exercise (admin)
    update(state) {
      state.status.update = requestStatus.loading;
    },
    updateSuccess(state) {
      state.status.update = requestStatus.success;
    },
    updateError(state) {
      state.status.update = requestStatus.error;
    },

    // Remove exercise (admin)
    remove(state) {
      state.status.remove = requestStatus.loading;
    },
    removeSuccess(state) {
      state.status.remove = requestStatus.success;
    },
    removeError(state) {
      state.status.remove = requestStatus.error;
    },

    // Request new exercise (trainer)
    requestExercise(state) {
      state.status.request = requestStatus.loading;
    },
    requestExerciseSuccess(state) {
      state.status.request = requestStatus.success;
    },
    requestExerciseError(state) {
      state.status.request = requestStatus.error;
    },

    // List exercise requests (admin)
    listRequests(state) {
      state.status.requests = requestStatus.loading;
    },
    listRequestsSuccess(state, action) {
      state.status.requests = requestStatus.success;
      state.data.exerciseRequests = action.payload;
    },
    listRequestsError(state) {
      state.status.requests = requestStatus.error;
    },

    // Approve exercise request (admin)
    approveRequest(state) {
      state.status.approve = requestStatus.loading;
    },
    approveRequestSuccess(state) {
      state.status.approve = requestStatus.success;
    },
    approveRequestError(state) {
      state.status.approve = requestStatus.error;
    },

    // Reject exercise request (admin)
    rejectRequest(state) {
      state.status.reject = requestStatus.loading;
    },
    rejectRequestSuccess(state) {
      state.status.reject = requestStatus.success;
    },
    rejectRequestError(state) {
      state.status.reject = requestStatus.error;
    },

    // Delete exercise request (admin)
    deleteRequest(state) {
      state.status.deleteRequest = requestStatus.loading;
    },
    deleteRequestSuccess(state) {
      state.status.deleteRequest = requestStatus.success;
    },
    deleteRequestError(state) {
      state.status.deleteRequest = requestStatus.error;
    },

    // Clear exercise
    clearExercise(state) {
      state.data.exercise = null;
      state.data.createdExercise = null;
    },

    // Reset status
    resetStatus(state) {
      state.status = initialState.status;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export default exerciseSlice;
